// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f06f89e","453":"b9ce35f9","455":"1935bdb6","977":"48927cc2"}[chunkId] + ".chunk.js";
};